// MUNKATÁRS-KERESŐ — a személy-választók KÖZÖS forrása (több feature használja, ezért nem egy feature
// `api.ts`-ében él: a kiadás-modulból emelve, amikor az eszköz-modul is ugyanerre a választóra szorult).

import { api } from '@/lib/api';

/**
 * A választó egy lapon lekért opció-plafonja — a szerződés felső határa (`/employees` `limit` max 200).
 * A belső állomány mérve 57 fő; ha ez valaha 200 fölé nőne, a választó lapozást kíván, nem nagyobb számot.
 */
const MAX_EMPLOYEE_OPTIONS = 200;

/** A MEGJELENÍTENDŐ név a hívó nyelve szerinti sorrendben; végső mentsvár az e-mail, majd az azonosító. */
function nameOf(
  lang: string,
  e: { id: string; givenName: string | null; familyName: string | null; email: string | null },
): string {
  const parts = lang === 'en' ? [e.givenName, e.familyName] : [e.familyName, e.givenName];
  const full = parts.filter((p): p is string => typeof p === 'string' && p.trim() !== '').join(' ');
  if (full !== '') return full;
  return e.email !== null && e.email.trim() !== '' ? e.email : e.id;
}

/**
 * MUNKATÁRS-kereső a személy-választókhoz (kiadás-űrlap, tömeges besorolás, eszköz birtokosa és „kinek igénylem")
 * — a központi címtárat (`/employees`) kérdezi, SZERVER-oldali kereséssel.
 *
 * MIÉRT szerver-oldali: a munkatárs-címtár nem az adott lap adata, és fölösleges lenne minden lap-betöltéskor
 * egészben lehúzni egy olyan mezőhöz, amit a sorok töredékén töltenek ki.
 *
 * JOG: a `/employees` az `employees.view` jogot kéri — aki nem látja a címtárat, annak a választó üres listát ad
 * (a mező opcionális, a művelet nélküle is elvégezhető).
 */
export function employeeSearch(
  lang: string,
): (q: string) => Promise<{ id: string; label: string }[]> {
  return async (q: string) => {
    const res = await api.employees.query({
      query: {
        ...(q === '' ? {} : { q }),
        lang: lang === 'en' ? 'en' : 'hu',
        // A TELJES belső címtár elfér egy lapon — és ez követelmény, nem optimalizálás: a választó
        // GÖRGETHETŐ listát ad, nem lapozót, tehát amit nem kérünk le, az elérhetetlen. 20-as lappal a
        // névsor a K betűnél ért véget, és az utána következő munkatársakat SEHOGY nem lehetett kiválasztani
        // (mérve: 57 élő belső identity). A 200 a szerződés felső határa, a mai állomány háromszorosa.
        limit: MAX_EMPLOYEE_OPTIONS,
      },
    });
    if (res.status !== 200) return [];
    return res.body.employees.map((e) => ({
      id: e.id,
      // A címtár a NÉV-részeket adja; a megjelenítendő alak a hívó nyelve szerinti sorrend (a szerver a
      // `displayName`-t is ugyanígy állítja össze), végső esetben az e-mail.
      label: nameOf(lang, e),
    }));
  };
}
